module.exports = __webpack_public_path__ + "img/Parlament Wien.jpeg";